import { eco } from '@/utils/imagepath';
import React from 'react';

const PrioritizeSection = ({ themeData }: any) => {
  return (
    <>
      {' '}
      <style type="text/css">
        {` 
            .safety-section::after{
              background:#${themeData?.theme_4?.home?.section_8?.part_two?.bg_color}
            }
          `}
      </style>
      <section className="safety-section">
        <div className="container">
          <div className="safety-info-grid">
            <div className="row">
              <div className="col-md-6">
                <div className="split-img">
                  <img
                    src={
                      themeData?.theme_4?.home?.section_8?.part_one
                        ?.section_image
                    }
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="section-title text-start mt-5">
                  <h2 className="ps-0">
                    {themeData?.theme_4?.home?.section_8?.part_one?.title}
                  </h2>
                  <h4>
                    {themeData?.theme_4?.home?.section_8?.part_one?.sub_title}
                  </h4>
                  <p>
                    {themeData?.theme_4?.home?.section_8?.part_one?.paragraph}
                  </p>
                </div>
                <div className="safety-content">
                  <ul>
                    {themeData?.theme_4?.home?.section_8?.part_one?.card_section?.collection.map(
                      (item: any) => {
                        return (
                          <li>
                            <h3>{item.collection_title}</h3>
                            <p>{item.collection_paragraph}</p>
                          </li>
                        );
                      }
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4 d-none">
            <div className="col-md-3">
              <div className="safety-list-card-desc">
                <img src={eco} alt="" />
                <h3
                  className=""
                  style={{
                    color: `#${themeData?.theme_4?.home?.section_8?.part_two?.text_color}`,
                  }}
                >
                  {themeData?.theme_4?.home?.section_8?.part_two?.title}
                </h3>
                <p
                  className=""
                  style={{
                    color: `#${themeData?.theme_4?.home?.section_8?.part_two?.text_color}`,
                  }}
                >
                  {themeData?.theme_4?.home?.section_8?.part_two?.paragraph}
                </p>
              </div>
            </div>

            {themeData?.theme_4?.home?.section_8?.part_two?.card_section?.collection.map(
              (item: any) => {
                return (
                  <>
                    <div className="col-md-3 d-flex">
                      <div className="safety-list-card safety-list-card-bg1">
                        <h3
                          style={{
                            color: `#${themeData?.theme_4?.home?.section_8?.part_two?.text_color}`,
                          }}
                        >
                          {item.collection_title}
                        </h3>
                        <p
                          style={{
                            color: `#${themeData?.theme_4?.home?.section_8?.part_two?.text_color}`,
                          }}
                        >
                          {item.collection_paragraph}
                        </p>
                      </div>
                    </div>
                  </>
                );
              }
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default PrioritizeSection;
